export default __webpack_public_path__ + "static/media/image-header-mobile.399f71e7.jpg";